import React from 'react';
import clsx from 'clsx';
import type {FormType, InputForm} from '@netx/core-components/Form';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormSubFieldName,
	getCustomFormBaseFieldName,
} from '../../utils';
import {LegacyFormCustomFormItem} from '../CustomFormItem/LegacyFormCustomFormItem';
import {
	customFormClasses,
	getCustomFormUtilityClass,
	CUSTOM_FORM_CLASS_NAME,
	type CustomFormClasses,
	type CustomFormClassKey,
} from './customFormClasses';

type LegacyFormCustomFormOwnerState = WithClasses<CustomFormClasses, {}>;

const useUtilityClasses = (props: LegacyFormCustomFormOwnerState) => {
	const {classes} = props;
	const slots = {
		root: ['root'],
	} as const;
	return composeClasses<CustomFormClassKey>(
		slots,
		getCustomFormUtilityClass,
		classes,
	);
};

export const LegacyFormCustomFormRoot = styled('div', {
	name: CUSTOM_FORM_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	width: '100%',
}));

export type LegacyFormCustomFormProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> = WithClasses<
	CustomFormClasses,
	{
		disabled?: boolean;
		items: ICustomFormItem[];
		form: FormType<TValues>;
		inputForm: InputForm<TValues>;
	}
>;

export const LegacyFormCustomFormPrimitive = <
	FV extends CustomFormFormValues = CustomFormFormValues,
>({
	classes: _classes,
	className,
	disabled,
	form,
	inputForm,
	items,
}: LegacyFormCustomFormProps<FV>) => {
	const ownerState: LegacyFormCustomFormOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<LegacyFormCustomFormRoot className={clsx(classes.root, className)}>
			{items.map((item) => {
				// GROSS!
				const isCheckboxes = item.type === 'checkboxes';
				const value =
					isCheckboxes && Array.isArray(item.value)
						? item.value.reduce<Record<string, boolean>>((accum, i) => {
								const subFieldName = getCustomFormSubFieldName(item, i);
								const formValue = form.values[subFieldName];
								return {
									...accum,
									[subFieldName]: formValue === true || formValue === 'true',
								};
						  }, {})
						: form.values[getCustomFormBaseFieldName(item)];

				return (
					<LegacyFormCustomFormItem
						disabled={disabled}
						error={form.errors[getCustomFormBaseFieldName(item)]}
						value={value}
						inputForm={inputForm}
						key={item.label.key}
						item={item}
					/>
				);
			})}
		</LegacyFormCustomFormRoot>
	);
};

export const LegacyFormCustomForm = LegacyFormCustomFormPrimitive;

export default LegacyFormCustomForm;
